import { faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

import { colours } from '../../../assets/colours';
import './GreenCheckOverlay.css';

interface GreenCheckOverlayProps {
  masterclass?: boolean;
  text?: string;
}

export function GreenCheckOverlay({ masterclass, text }: GreenCheckOverlayProps) {
  const { t } = useTranslation();
  return (
    <div className="popup-overlay">
      {masterclass ? (
        <div className="complete-cont" role="alert" aria-live="assertive" aria-atomic="true">
          {' '}
          <FontAwesomeIcon
            icon={faCircleCheck}
            style={{
              paddingRight: '10px',
            }}
            aria-hidden="true"
          />{' '}
          {text || t('GC001')}
        </div>
      ) : (
        <div
          role="alert"
          aria-live="assertive"
          aria-atomic="true"
          style={{
            position: 'fixed',
            left: 'calc(50% - 75px)',
            top: 'calc(50% - 150px)',
          }}
        >
          <FontAwesomeIcon
            icon={faCircleCheck}
            color={colours.green}
            style={{
              height: '150px',
              width: '150px',
            }}
            aria-hidden="true"
          />
          <span className="sr-only">{text || t('GC001')}</span>
        </div>
      )}
    </div>
  );
}
